export const TALENTS_BASIC_INPUTS_NAME: { [key: string]: string } = {
  EMAIL: 'email',
  PHONE: 'phone',
};
// todo move to language file without duplications
export const Validations = {
  Email: {
    Required: {
      text: 'Email is Required',
    },
    Invalid: {
      text: 'Invalid email address',
    },
  },
  Phone: {
    Required: {
      text: 'Phone is Required',
    },
    Invalid: {
      text: 'Invalid phone format',
    },
  },
};
